import type { TeaserCardProps } from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-card](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-card)
 * - Storybook: [Subcomponents > TeaserCard](https://designsystem.dn.se/?path=/docs/section-subcomponents-teaserdot--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/assets/teaser/teaser.scss'`
 */
export const TeaserCard = ({ areaType, targetLink, theme, classNames, attributes, children }: TeaserCardProps) => {
  const componentClassName = 'ds-teaser'

  const classes = formatClassString([
    componentClassName,
    areaType && areaType !== 'main' && `${componentClassName}--${areaType}`,
    areaType == 'bauta' && 'ds-dark',
    theme && `ds-theme--${theme}`,
    classNames,
  ])

  if (targetLink) {
    return (
      <a className={classes} href={targetLink} {...attributes}>
        {children}
      </a>
    )
  }

  return (
    <div className={classes} {...attributes}>
      {children}
    </div>
  )
}
